/**
 * Backend translation field kinds (mirrors the API's CompetencyTranslationFieldKind enum,
 * serialized as PascalCase strings). Used to tag which field a translation change targets.
 */
export const CompetencyTranslationFieldKind = {
    GROUP_NAME: 'GroupName',
    GROUP_DESCRIPTION: 'GroupDescription',
    COMPETENCY_NAME: 'CompetencyName',
    COMPETENCY_DESCRIPTION: 'CompetencyDescription',
    QUESTION_LABEL: 'QuestionLabel',
    OPTION_LABEL: 'OptionLabel',
} as const;

export type CompetencyTranslationFieldKind =
    (typeof CompetencyTranslationFieldKind)[keyof typeof CompetencyTranslationFieldKind];
